import { DOWNLOAD_INVALID_FILES, DOWNLOAD_INVALID_FILES_SUCCESS, DOWNLOAD_INVALID_FILES_ERROR, DOWNLOAD_INVALID_FILES_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadInvalidFiles = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_INVALID_FILES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_INVALID_FILES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_INVALID_FILES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_INVALID_FILES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadInvalidFiles;
